import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useForm } from '../../../hooks/useForm';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select } from '@mui/material';
import { getListTypesComponent } from '../../../redux/actions/flows';
import { useDispatch } from 'react-redux';

export const CreateComponent = ({ flowManager, open, data, orders, typeAction, onSave, setOpen, getImputValid }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [{ userSession }] = useDataAuth();
    const { listTypesComponent, listSubTypesComponent, getSubTypesComponent } = flowManager;
    const [listImput, setlistImput] = useState([]);

    const getInitObject = () =>
        typeAction === "EDIT"
            ? data
            : { order: orders.nextOrder, body: {} };

    const [
        { type_component, subtype_component, order, description, replace, input, insert, body },
        handleInputChange,
        handleDirectInputChange
    ] = useForm(getInitObject());

    const handleSubmit = () => {
        let dto = { type_component, subtype_component, order, description, replace, input, insert, body };
        onSave(dto, data.order);
        setOpen(false);
    }

    const handleSelectType = (obj) => {
        handleDirectInputChange(obj.name, obj.value);
        getSubTypesComponent(obj.value);
    }

    useEffect(() => {
        if (listTypesComponent.length === 0)
            dispatch(getListTypesComponent(userSession.token));
        if (typeAction === "EDIT")
            getSubTypesComponent(data.type_component);
        setlistImput(getImputValid(order));
    }, [order]);

    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth
                maxWidth='sm'
                disableEscapeKeyDown
                disableBackdropClick
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        {t("flows.flowComponentFormTitle")}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ marginTop: 2 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    id={'Idtype_component'}
                                    name={'type_component'}
                                    select
                                    fullWidth
                                    required
                                    label='Tipo'
                                    variant="outlined"
                                    value={type_component || ''}
                                    onChange={(e) => handleSelectType(e.target)}
                                    size="small"
                                    defaultValue="none"
                                >
                                    <MenuItem
                                        key=""
                                        value=""
                                        disabled
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        select an option
                                    </MenuItem>
                                    {listTypesComponent.map((item) => (
                                        <MenuItem
                                            key={item.type_component}
                                            value={item.type_component}
                                            sx={{ fontWeight: 'bold' }}
                                        >
                                            {item.type_component}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    id={'Idsubtype_component'}
                                    name={'subtype_component'}
                                    select
                                    fullWidth
                                    required
                                    label='Sub tipo'
                                    variant="outlined"
                                    value={subtype_component || ''}
                                    onChange={handleInputChange}
                                    size="small"
                                    defaultValue="none"
                                >
                                    <MenuItem
                                        key=""
                                        value=""
                                        disabled
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        select an option
                                    </MenuItem>
                                    {listSubTypesComponent.map((item) => (
                                        <MenuItem
                                            key={item.subtype_component}
                                            value={item.subtype_component}
                                            sx={{ fontWeight: 'bold' }}
                                        >
                                            {item.subtype_component}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <FormControl fullWidth required size="small">
                                    <InputLabel>Orden</InputLabel>
                                    <Select
                                        name="order"
                                        label="Orden"
                                        value={order}
                                        onChange={handleInputChange}
                                    >
                                        {orders.listOrders.map((item) => (
                                            <MenuItem key={item} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    required
                                    fullWidth
                                    label='Descripción'
                                    InputLabelProps={{ shrink: true }}
                                    size='small'
                                    variant='outlined'
                                    name='description'
                                    value={description}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <FormControl fullWidth required size="small"
                                >
                                    <InputLabel>Input asociado</InputLabel>
                                    <Select
                                        name="input"
                                        label="Input asociado"
                                        value={input}
                                        onChange={handleInputChange}
                                    >
                                        {listImput.map((item) => (
                                            <MenuItem key={item} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    required={type_component === 'parser'}
                                    fullWidth
                                    label='Replace'
                                    InputLabelProps={{ shrink: true }}
                                    size='small'
                                    variant='outlined'
                                    name='replace'
                                    value={replace}
                                    disabled={type_component !== 'parser'}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    required
                                    fullWidth
                                    label='Insert'
                                    InputLabelProps={{ shrink: true }}
                                    size='small'
                                    variant='outlined'
                                    name='insert'
                                    value={insert}
                                    onChange={handleInputChange}
                                    disabled={type_component !== 'parser'}
                                />
                            </Grid>
                        </Grid>

                        <Box>
                            <ActionButtons
                                onCancel={() => setOpen(false)}
                                onSubmit={handleSubmit}
                                submitLabel="Guardar"
                            />
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}